export default "__VITE_ASSET__uYLIMZ6x__"